import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appProductMenuSectionHeaderInflatorContainer]',
  standalone: false
})
export class ProductMenuSectionHeaderInflatorContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
